import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: whitesmoke;
`;

export const NavBarContainer = styled.div`
  width: 50vw;
  background-color: white;
  border-radius: 2%;
  border: 1px solid whitesmoke;
  padding: 0px !important;

  @media (max-width: 768px) {
    width: 90vw;
  }
`;

export const Container = styled.div`
  margin-top:10vh;
  margin-bottom:10vh;
  align-items:center;
`;

export const Header = styled.div`
  height: 10vh;
  width:50vw;
  display:flex;
  justify-content:center;
  background-color:#02475c;
  padding: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  @media (max-width: 768px) {
    width: 90vw;
  }
 `;

export const Subheader = styled.div`
  height: 30vh;
  width:50vw;
  display:flex;
  align-items:center;
  justify-content:center;
  background-color:white;
  margin-top:30vw;

  @media (max-width: 768px) {
    width: 90vw;
  }
`;

export const OTPhelper = styled.span`
  display: block;
  font-size: smaller;
  color: red;
  text-align: center;
  width: 100%;
`;

 

